// import $ from "jquery";
import debug from 'bows/dist/bows.min.js';
import debounce from 'lodash.debounce';
const log = debug("filter");

const filters = document.querySelectorAll('.facet');

function filterToggle($this) {
  $this.classList.toggle('facet--active');
}

function doFilters() {
  filters.forEach(filter => {
    let btn = filter.querySelector('.facet__toggler');

    if (btn) {
      btn.addEventListener('click', function () {
        filterToggle(filter);
      });

    }

    filter.addEventListener('mouseleave', function () {
      log('mouseleave');
      this.classList.remove('facet--active');
    });

    filter.addEventListener('focusout', function () {
      setTimeout(() => {
        let focused = filter.querySelector(':focus');
        if (focused === null) {
          this.classList.remove('facet--active');
        }
      }, 250);

    });

  });
}

var getSiblings = function (elem) {
  return Array.prototype.filter.call(elem.parentNode.children, function (sibling) {
    return sibling !== elem;
  });
};

function removeOpen($this) {
  //if any sibling has open attribute, remove it
  let siblings = getSiblings($this);
  siblings.forEach(sib => {
    if (sib.hasAttribute('open')) {
      sib.removeAttribute('open');
      sib.children[0].setAttribute('aria-expanded', 'false')
      sib.children[0].setAttribute('aria-pressed', 'false');
    }
  });
}

function closeFilter(dfilters) {
  dfilters.forEach(elem => {
    //log(elem);
    let btn = elem.querySelector('summary');
    log(btn)
    if (btn) {
      btn.addEventListener('click', function () {
        removeOpen(elem);
      });
    }

    if (elem.hasAttribute('open')) {
      elem.removeAttribute('open');
    }

    elem.addEventListener('mouseleave', function () {
      log('mouseleave');
      // this.removeAttribute('open');
      // this.children[0].setAttribute('aria-expanded', 'false')
      // this.children[0].setAttribute('aria-pressed', 'false');
    });

    elem.addEventListener('focusout', function () {
      log('focusout')
      log(document.body.clientWidth);
      if (document.body.clientWidth >= 768) {
        setTimeout(() => {
          let focused = elem.querySelector(':focus');
          if (focused === null) {
            this.removeAttribute('open');
            this.children[0].setAttribute('aria-expanded', 'false')
            this.children[0].setAttribute('aria-pressed', 'false');
          }
        }, 250);
      }
    });
  });
}

// Show an element
var show = function (elem) {
  elem.style.display = 'block';
};

// Hide an element
var hide = function (elem) {
  if (document.body.clientWidth <= 1024) {
    elem.style.display = 'none';
  }
};

// Toggle element visibility
var toggle = function (elem) {
  if (document.body.clientWidth <= 1024) {
    // If the element is visible, hide it
    if (window.getComputedStyle(elem).display === 'block') {
      hide(elem);
      return;
    }

    // Otherwise, show it
    show(elem);
  }

};

function makeLegendBtn(legendBtn) {
  if (document.body.clientWidth <= 1024) {
    legendBtn.forEach(lb => {
      lb.setAttribute('role', 'button');
      lb.setAttribute('tabindex', '0');
    })
  } else {
    legendBtn.forEach(lb => {
      lb.removeAttribute('role', 'button');
      lb.nextElementSibling.removeAttribute('style');
    });

  }
}

let formDate = document.querySelector('.form--date .js-form-item-field-event-date-value');
let formDateLabel;
let formDateInput;
let tempDate;


function getDate(msDate) {
  let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  let newDate = new Date(msDate);
  let convertedDate = new Date(newDate.getTime() - newDate.getTimezoneOffset() * -60000);
  let finalDate = convertedDate.toLocaleDateString("en-US", options);
  const day = convertedDate.toLocaleString('default', { day: '2-digit',timeZone: 'UTC' });
  const month = convertedDate.toLocaleString('default', { month: '2-digit',timeZone: 'UTC' });
  const year = convertedDate.toLocaleString('default', { year: 'numeric',timeZone: 'UTC' });
  let recurDate = year + month + day;
  log(formDate);
  log(formDateInput);
  formDateLabel.innerText = finalDate;
  formDateLabel.classList.add('show');
  getDay(finalDate);
  if (document.querySelectorAll("#block-views-block-events-block-1")) {
    showRecur(recurDate);
  }
}

function getDay(finalDate) {
  let day = finalDate.split(',', 1);
  let formDateHours = document.querySelectorAll('.tpc-hours');
  formDateHours.forEach(fdh => {
    fdh.setAttribute('hidden', true);
    if (day[0] === fdh.dataset.tpcHours) {
      fdh.removeAttribute('hidden');
    }
  });
  let whatsOnItems = document.querySelector('.view-list');
  if ( whatsOnItems ) {
    if ( day == 'Monday' ) {
      whatsOnItems.setAttribute('hidden', true);
      whatsOnItems.style.display = 'none';
    } else {
      whatsOnItems.removeAttribute('hidden');
      whatsOnItems.style.display = 'flex';
    }
  }
}

function showRecur(recurDate) {
  let recurCards = document.querySelectorAll("[id^='recurring-']");
  if ( recurCards.length > 0 && recurDate != "All" ) {
    for ( var rci = 0; rci < recurCards.length; rci++){
      let dateArr = recurCards[rci].getAttribute('data-dates').split(" ");
      for (var i = 0; i < dateArr.length; i++) {
//        console.log(dateArr[i]);
        //Do something
        if ( dateArr[i] == recurDate ) {
          let cardArr = recurCards[rci].id.split('-');
          if (cardArr.length == 2) {
            let cardID = 'card-' + cardArr[1];
            let card = document.getElementById(cardID);
            if ( card ) {
              card.classList.remove("hidden");
            }
          }
        }
      }
    }
  } else {
    if ( recurDate == "All" ) {
      let cardArr = recurCards[rci].id.split('-');
      if (cardArr.length == 2) {
        let cardID = 'card-' + cardArr[1];
        let card = document.getElementById(cardID);
        if ( card ) {
          card.classList.remove("hidden");
        }
      }
    }
  }
}

export function init() {
  if (filters) {
    doFilters();
  }

  if (formDate) {

    formDateLabel = formDate.querySelector('label');
    formDateInput = formDate.querySelector('.form-date');
    log(formDateInput.value);
    log(formDateLabel);
    // Get local timezone offset
    let tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    // adjust the time for the local timezone and then put the results into ISO format
    formDateInput.value = (new Date(Date.now() - tzoffset)).toISOString().slice(0, 10);
    //log(formDateInput.value);
    let msDate = Date.parse(formDateInput.value);
    getDate(msDate);

  }


  Drupal.behaviors.tpc_filter = {
    attach: (context, settings) => {
      /**
       * FIXME:
       *
       * Two possible improvements needed:
       * 1) context is a DOM element representing the area being attached. On page load this is
       *    the body (or html?!) element. On ajax, it's just the <div> being inserted. Best
       *    practice is to use context for querySelectorAll to ensure you're not altering content
       *    outside of the HTML being initialized. Example: `context.querySelectorAll('.facet');`
       * 2) you may need to wrap some/all of this code in a "run once" check for actions which
       *    do not need to occur every time.
       */


      let dfilters = context.querySelectorAll('.form--filters details.js-form-wrapper');

      let eventFeatures = context.querySelector('[data-drupal-selector="edit-field-event-features-value"] .fieldset-wrapper');
      let eventType = context.querySelector('[data-drupal-selector="edit-field-event-type-target-id-1"] .form-checkboxes');
      let startDate = context.querySelector('.js-form-item-field-event-date-value-1');
      let fromDate = context.querySelector('[data-drupal-selector="edit-field-event-date-value-1"]');
      let endDate = context.querySelector('.js-form-item-field-event-date-end-value');


      let filterForm = document.querySelector('.form--filters');
      let filterSubmit = context.querySelector('.js-form-submit');
      formDate = context.querySelector('.form--date .js-form-item-field-event-date-value');

      if (filterForm) {
        let filterBtn = document.createElement('button');
        filterBtn.className = 'btn btn--primary-fill filter__mobile-btn';
        filterBtn.innerHTML = '<span>Filter</span>';
        filterForm.prepend(filterBtn);
        let elem = document.querySelector('.bef-exposed-form');

        let wrapper = document.createElement('div');
        wrapper.className = 'filter__wrap';
        wrapper.innerHTML = '<span>Filter</span>';
        let filterCloseBtn = document.createElement('button');
        filterCloseBtn.className = 'filter__close';
        filterCloseBtn.innerHTML = '<span class="a11y">Close Filter</span><svg class="toggle-close" width="20" height="20"><use xlink:href="#icon-close" href="#icon-close"></use></svg>';

        if (elem) {
          elem.parentNode.insertBefore(wrapper, elem);
          wrapper.appendChild(filterCloseBtn);
          wrapper.appendChild(elem);
        }
        log(filterBtn);
        if (filterBtn) {
          filterBtn.addEventListener('click', function () {
            document.body.classList.add('filter-open');
          });
        }

        if (filterCloseBtn) {
          filterCloseBtn.addEventListener('click', function () {
            document.body.classList.remove('filter-open');
          });
        }

        if (filterSubmit) {
          filterSubmit.addEventListener('click', function () {
            setTimeout(() => {
              document.body.classList.remove('filter-open');
            }, 1000);
          });
        }

      }

      if (dfilters) {
        //log(dfilters);
        closeFilter(dfilters);
      }

      if (eventType && eventFeatures) {
        log(eventType);
        eventFeatures.append(eventType);
      }

      if (startDate && endDate) {
        log(startDate);
        log(endDate);
        if (fromDate) {
          // Test value and set to today if not curently set
          if ( fromDate.value == '' ) {
            const date = new Date();
            fromDate.value = date.toISOString().split('T')[0];
          }
        }

        let dateWrap = document.createElement('fieldset');
        dateWrap.className = 'form-item date-range form-wrapper';
        dateWrap.innerHTML = '<legend><span class="fieldset-legend">Date Range</span></legend><div class="date-range__wrap"></div>';
        let rangeWrap = dateWrap.querySelector('.date-range__wrap');
        startDate.before(dateWrap);
        rangeWrap.appendChild(startDate);
        rangeWrap.appendChild(endDate);
      }

      let legendBtn;
      setTimeout(() => {
        legendBtn = context.querySelectorAll('.form--filters legend');

        if (legendBtn) {
          log(legendBtn);
          legendBtn.forEach(lb => {
            lb.addEventListener('click', function () {
              //log(this.nextElementSibling);
              toggle(lb.nextElementSibling);
            });

            // Handle keydown events for keyboard users
            lb.addEventListener('keydown', e => {
              log('test');
              log(e);

              if (e.key == 'Enter' || e.keyCode == 13) {
                toggle(lb.nextElementSibling);

              }
            });

            // lb.addEventListener('mouseleave', function () {
            // 	hide(lb.nextElementSibling);
            // });
          })
          makeLegendBtn(legendBtn);
          window.addEventListener('resize', debounce(function () {
            makeLegendBtn(legendBtn);
          }, 100));
        }
      }, 200);





      if (formDate) {

        formDateLabel = formDate.querySelector('label');
        formDateInput = formDate.querySelector('.form-date');

        log(formDateInput.value);
        log(formDateLabel);
        let msDate = Date.parse(formDateInput.value);
        getDate(msDate);

        formDateInput.addEventListener('change', (event) => {
          let msDate = Date.parse(event.target.value);
          getDate(msDate);
        });
      }

      //on page load set date value to today's date
      //get today's date and pass in as label text
      //on date change and after submission get new date and replace label text
    }
  };
}

export default {
  init
};
